(function (global) {
  "use strict";

  function initAutoMarquees(defaultSlice = 2) {
    document.querySelectorAll(".dhn-marquee").forEach((wrap) => {
      const track = wrap.querySelector(".dhn-marquee-content");
      if (!track) return;

      /* count items (only real news nodes) */
      const items = track.querySelectorAll(".dhn-marquee-item").length || 1;

      /* slice seconds per item, via data-slice or fallback */
      const slice = parseFloat(wrap.dataset.slice) || defaultSlice;
      const duration = `${items * slice}s`;

      /* ① write the CSS variable (harmless even if plugin strips it) */
      wrap.style.setProperty("--marquee-speed", duration);

      /* ② override the actual long-hand property so we’re future-proof */
      track.style.animationDuration = duration;

      /* optional gap override */
      if (wrap.dataset.gap) {
        wrap.style.setProperty("--marquee-gap", wrap.dataset.gap);
        track.style.gap = wrap.dataset.gap; // direct override
      }

      /* quick dev log — remove when happy */
      console.log(`[marquee] ${items} items × ${slice}s → ${duration}`);
    });
  }

  /* boot once */
  if (document.readyState !== "loading") {
    initAutoMarquees();
  } else {
    global.addEventListener("DOMContentLoaded", () => initAutoMarquees());
  }

  /* expose for list updates after AJAX, etc. */
  global.initAutoMarquees = initAutoMarquees;
})(window);
